import { useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';
import useTrade from './useTrade';

export interface TradeListContextValue extends ReturnType<typeof useTrade> {
  conversation?: Conversation.Conversation;
}

export const TradeListContext = createNamedContext<TradeListContextValue | null>(
  'TradeListContext',
  null,
);

export const useTradeListContext = () => {
  const value = useContext(TradeListContext);

  if (value === null) {
    throw new Error(
      'useTradeListContext should be used in a context of TradeListContext.Provider component',
    );
  }

  return value;
};
